import { AssetClassFilter } from '@/__generated__/graphql';

export interface DealRegistryFiltersStructure {
  assetClass: AssetClassFilter[];
  funnel: string[];
}

export enum ASSET_CLASS {
  PRIVATE_EQUITY = 'Private Equity',
  PRIVATE_CREDIT = 'Private Credit',
  PRIVATE_REAL_ASSETS = 'Private Real Assets',
  NOT_SET = 'Not Set'
}
